var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C13.9705 0 18 4.02955 18 9C18 13.9705 13.9705 18 9 18C4.02955 18 0 13.9705 0 9C0 4.02955 4.02955 0 9 0ZM12.1046 12.6687C12.2699 12.161 13.0459 7.09895 13.1412 6.10118C13.1703 5.79927 13.0745 5.59841 12.888 5.50841C12.6618 5.4 12.3271 5.454 11.9381 5.59432C11.405 5.78659 4.59164 8.67927 4.19809 8.847C3.825 9.00573 3.47195 9.17836 3.47195 9.42914C3.47195 9.60545 3.57668 9.70445 3.86468 9.80714C4.16414 9.91391 4.91891 10.1426 5.36523 10.2657C5.79477 10.3844 6.28282 10.2813 6.55691 10.1111C6.84695 9.93068 10.1982 7.68886 10.4384 7.49209C10.6785 7.29573 10.8704 7.54732 10.674 7.74409C10.4776 7.94045 8.17773 10.1729 7.87418 10.4821C7.50559 10.8573 7.767 11.2463 8.0145 11.4022C8.29636 11.5801 10.3255 12.9408 10.631 13.1592C10.9366 13.3777 11.2463 13.4767 11.5302 13.4767C11.8141 13.4763 11.9635 13.1024 12.1046 12.6687Z",
    fill: "#80BE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.412e66314e87cc60dba9991633a7cabc.svg";
export { ForwardRef as ReactComponent };